import EditOutlined from '@ant-design/icons/EditOutlined'
import { useDocumentEditContext } from 'features/documentUpload/DocumentEditContext'
import React from 'react'

import { CategorySelector } from './CategorySelector'
import { NotesEditor } from './NotesEditor'

export const DocumentMetadataEditor: React.FC = () => {
  const {
    documentData: {
      notes,
      setNotes,
      categories,
      setCategories,
      existingCategories,
      isLoading: isLoadingDocumentData,
    },
  } = useDocumentEditContext()
  return (
    <>
      <CategorySelector
        options={existingCategories}
        selected={categories}
        setSelected={setCategories}
        isLoading={isLoadingDocumentData}
      />
      <NotesEditor
        isLoading={isLoadingDocumentData}
        label={
          <span>
            <EditOutlined /> Document Notes
          </span>
        }
        value={notes}
        setValue={setNotes}
      />
    </>
  )
}
